import './Contacts.scss';
import * as React from 'react';
import { IActions as IContactActions, actionCreator as contactActions } from '../../common/store/contacts/actions/creators';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IState as IContactState } from '../../common/store/contacts/state';
import { IState as IRoomState } from '../room/store/state';
import { IState as ITagState } from '../tags/store/state';
import { IActions as ITagsActions, actionCreator as tagsActions } from '../tags/store/actions/creators';
import { IState as IReminderState } from '../../common/store/reminders/state';
import { IActions as IReminderActions, actionCreator as remindersActions } from '../../common/store/reminders/actions/creators';
import { IState as IInfosState } from '../../common/store/infos/state';
import { IActions as IInfosActions, actionCreator as infosActions } from '../../common/store/infos/actions/creators';
import { IActions as ISubscriptionActions, actionCreator as subscriptionsActions } from '../../common/store/subscriptions/actions/creators';
import ContactList from './components/List/ContactList';
import { Contact } from './components/Detail/Contact';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { IApplicationState } from '../../store/ApplicationState';
import { connect } from 'react-redux';
import Filters from './components/Filter/Filters';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { Export } from './components/BottomListActions/Export';
import { Buttons } from './components/Detail/Buttons';
import Alert from '@material-ui/lab/Alert';
import { ListPagination } from './components/BottomListActions/ListPagination';
import { tag } from '../../model/tag';
import { createContact, emptyContact } from '../../model/contact';
import { NewContact } from './components/Detail/NewContact';
import ContactReservationDialog from './components/ContactReservationDIalog/ContactReservationDialog';
import { emptyReminder, reminder } from '../../model/reminder';
import ReminderDialog from '../reminders/List/ReminderDialog';
import ReminderDialogList from '../reminders/List/ReminderDialogList';
import { styles } from './styles';
import AddContactSubscriptionDialog from './components/Subscription/AddContactSubscriptionDialog';
import { contactInsurance, contactMedicalExamination } from '../../model/contactsubscription';
import AccessDialog from './components/Detail/AccessDialog';
import { forcedAccess, passage } from '../../model/access';
import { infos } from '../../model/infos';
import { InformationDialog } from './components/Infos/InformationDialog';
import { DeleteX } from '../drafts/components/DeleteButton';
import { invokeApi } from '../../common/networking/invoker';

// IRoomActions,
interface IProps extends IContactActions, ITagsActions, IReminderActions, IInfosActions, ISubscriptionActions, IContactState, ITagState, IRoomState, IReminderState, IInfosState, IMediaQueryProps, StyledComponentProps {
    navigateTo: (path: string) => void;
    match: {
        params: {
            id: string
        }
    }
}
interface IState {
    contactsCollapsed: boolean;
    openContactReservationDialog: boolean;
    openContactAccessDialog: boolean;
    openReminderDialog: boolean;
    openInfosDialog: boolean;
    openReminderDialogList: boolean;
    openSubscriptionDialog: boolean;
    fullnameOrEmail: string;
    sub: string;
    subscriptionType: string;
    tag?: tag;
    reminder?: reminder;
    selectedSub: string;
    passage?: passage;
}

const DefaultRowsPerPage = 10;

class CompContainer extends React.Component<IProps, IState> {
    state = {
        contactsCollapsed: false,
        openContactReservationDialog: false,
        openContactAccessDialog: false,
        openReminderDialog: false,
        openInfosDialog: false,
        openSubscriptionDialog: false,
        openReminderDialogList: false,
        fullnameOrEmail: "",
        sub: "",
        subscriptionType: "",
        tag: undefined,
        reminder: undefined,
        selectedSub: '',
        passage: undefined,
    };

    componentDidMount() {

        // if (!this.props.rooms || this.props.rooms.length === 0) {
        //     this.props.loadRooms();
        // }

        const { id } = this.props.match.params;

        // this.props.clearContactSelection();
        this.props.clearContactPurchased();

        // if (!this.props.contacts || this.props.contacts.length === 0) {
        this.props.loadContactsPaginated(``, ``, this.props.page, DefaultRowsPerPage).then(r => {
            const sub = r.contacts.length > 0 ? r.contacts[0].sub : ""
            if (sub && !id) {
                this.handleUserSelection(sub)
            }
        });
        // }
        if (!this.props.tags || this.props.tags.length === 0) {
            this.props.loadTags();
        }
        if (id) {
            this.props.loadContact(id);
            this.setState({ selectedSub: id });
        }
        else {
            this.props.clearContactSelection();
        }
    }
    handleUserSelection = (sub: string) => {
        this.setState({ contactsCollapsed: this.props.smallScreen ? true : this.state.contactsCollapsed });
        // this.props.navigateTo(`/private/Contacts/${sub}`);
        this.props.loadContact(sub);
        this.setState({ selectedSub: sub });
        // this.props.loadContactPurchased(sub);
        this.props.clearContactPurchased();
    }
    toggleCotactsSectionCollapse = () => {
        this.setState({ contactsCollapsed: !this.state.contactsCollapsed });
    }
    private handleChangeFullnameOrEmail = (val: string) => {
        this.setState({ fullnameOrEmail: val })
    }
    private handleChangeSub = (val: string) => {
        this.setState({ sub: val })
    }
    private handleChangeTagCode = (val?: tag) => {
        this.setState({ tag: val })
    }
    private search = (page: number, fullnameOrEmail: string, tag: tag) => {
        this.props.clearContactPurchased();
        this.props.loadContactsPaginated(fullnameOrEmail, tag ? tag.code : "", page, DefaultRowsPerPage)
    }
    printElem = (idElem: string) => {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>' + document.title + '</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(document.getElementById(idElem).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    }
    onNewContactClick = () => {
        this.props.clearContactSelection();
    }
    addNewUser = (newContact: createContact) => {
        this.props.addNewUser(newContact).then(v => {
            this.handleUserSelection(v.sub)
        })
    }
    setOpenContactReservationDialog = (open: boolean) => {
        if (open) {
            this.props.loadContactReservations(this.props.contact.sub);
        }
        this.setState({
            openContactReservationDialog: open
        })
    }
    setOpenReminderDialog = (open: boolean) => {
        this.setState({ openReminderDialog: open })
    }
    setOpenAccessDialog = (open: boolean) => {
        this.setState({ openContactAccessDialog: open })
    }
    setOpenReminderDialogList = (open: boolean) => {
        if (open === true) {
            this.props.loadContactReminders(this.props.contact.sub);
        }
        this.setState({ openReminderDialogList: open })
    }
    setOpenInformationDialogList = (open: boolean) => {
        if (open === true) {
            this.props.loadInfos(this.props.contact.sub);
        }
        this.setState({ openInfosDialog: open })
    }
    doneReminder = (r: reminder, done: boolean) => {
        r.done = done;
        this.props.saveReminder(r);

    }
    setBlcokDate = (val?: Date) => {
        // console.info("--------------------------------------------")
        // console.info(val);
        // this.setState({state.contacts, userId: c.sub, email: c.email}, contact: c});
        // this.setState(...contact: open})

    }
    saveInfos = (info: infos) => {
        console.log("saveInfos:", info);
        this.props.saveInfos(this.props.contact.sub, info);
    }
    deleteInfos = (id: string) => {
        console.log("deleteInfos:", id);
        this.props.deleteInfos(this.props.contact.sub, id);
    }
    saveReminder = (r: reminder) => {
        // console.info("--------------------------------------------")
        // console.info(r);
        if (r.expiresOn === undefined) {
            alert("Impostare una data di scadenza del promemoria");
            return;
        }

        if (r._id === undefined) {
            this.props.addReminder(r);
        }
        else {
            this.props.saveReminder(r);
        }
        this.setOpenReminderDialog(false);
    }
    newReminder = () => {
        this.setOpenReminderDialog(true);
        this.setState({ reminder: undefined });
    }
    openReminder = (id: string) => {
        this.setOpenReminderDialog(true);
        var r = this.props.selectedContactReminders.findIndex(c => c._id === id);
        if (r >= 0) {
            // console.log(this.props.selectedContactReminders[r]);
            this.setState({ reminder: this.props.selectedContactReminders[r] });
        } else {
            this.setState({ reminder: undefined });
        }
    }
    setOpenSubscriptionDialog = (open: boolean, tipo: string) => {
        this.setState({ openSubscriptionDialog: open, subscriptionType: tipo });
    }
    getSubscriptionType = (tipo: string) => {
        this.setOpenSubscriptionDialog(true, tipo);
    }
    saveSubscription = (item: any) => {
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.props.addContactSubscription(this.props.contact.sub, item);
        this.setOpenSubscriptionDialog(false, '');
    }
    saveAccess = (result: forcedAccess) => {
        console.info(result);
        this.props.saveAccessInfo(result);
        this.setOpenAccessDialog(false);
    }
    saveInsurance = (item: contactInsurance) => {
        // console.info("-------------------------------------------------")
        // console.info(item);
        // console.info(tipo);
        // console.info(this.props.contact._id);
        this.props.addContactInsurance(this.props.contact.sub, item);
        this.setOpenSubscriptionDialog(false, '');
    }
    saveMedicalExamination = (item: contactMedicalExamination) => {
        console.info("-------------------------------------------------")
        console.info(item);
        // console.info(tipo);
        console.info(this.props.contact._id);
        this.props.addContactMedical(this.props.contact.sub, item);
        this.setOpenSubscriptionDialog(false, '');
    }

    goToOblivion = (_sub: string, auth0: boolean) => {
        if (_sub) {
            invokeApi({
                path: '/api/ContactsAdmin/' + _sub + (auth0 ? '/oblivionauth0/' : '/oblivion/'),
                method: 'DELETE',
                responseType: 'json'
            }).then(resp => {
                console.info("--------------> goToOblivion RESPONSE", resp)
                alert("Questo utente è stato eliminato. Da domani non sarà più visibile.")
            })
            // logOut();
        }
    }

    render() {
        // const { id } = this.props.match.params;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        handleChangeFullnameOrEmail={this.handleChangeFullnameOrEmail}
                        handleChangeSub={this.handleChangeSub}
                        handleChangeTagCode={this.handleChangeTagCode}
                        fullnameOrEmail={this.state.fullnameOrEmail}
                        sub={this.state.sub}
                        loading={this.props.isLoadingContacts}
                        selctedTag={this.state.tag}
                        search={this.search}
                        new={this.onNewContactClick}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Paper title='Elenco'
                        collapsed={this.props.smallScreen ? this.state.contactsCollapsed : false}
                        toggleCollapse={this.toggleCotactsSectionCollapse}
                        fullHeight={false}
                        contentContainerStyle={this.props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}
                    >
                        <Grid container spacing={1} justify={"center"} >
                            {this.props.isLoadingContacts ?
                                <Grid item xs={12} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                :
                                <>
                                    <Grid item xs={12} >
                                        <ContactList
                                            contactList={this.props.contacts}
                                            roomList={this.props.rooms}
                                            selected={this.state.selectedSub}
                                            onContactClick={this.handleUserSelection}
                                            navigateTo={this.props.navigateTo}
                                        />
                                    </Grid>
                                    <Grid container >
                                        <Grid item style={{ flexGrow: 4 }}>
                                            <ListPagination next={() => { this.search(this.props.page + 1, this.state.fullnameOrEmail, this.state.tag) }}
                                                prev={() => { this.search(this.props.page - 1, this.state.fullnameOrEmail, this.state.tag) }}
                                                page={this.props.page}
                                                totalRows={this.props.totalRows} rowsPerPage={DefaultRowsPerPage} />
                                        </Grid>
                                        <Grid item>
                                            <Export print={() => { window.print(); }}
                                                download={() => { }} />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6}>
                    {/* {this.props.contact &&
                        this.props.contact._id &&  */}
                    <Paper title='Dati' fullHeight contentContainerStyle={{ padding: 8 }} id="ContactData">
                        <Grid container spacing={1} justify={"center"}>
                            {this.props.isLoadingContacts || this.props.isLoadingContact ?
                                <Grid item xs={12} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                : (this.props.isContactFetchInError ?
                                    <Grid item xs={12}>
                                        <Alert severity="error">
                                            <>
                                                L'utente ricercato non è ancora stato attivato completamente.<br />
                                                <p>errore: <b>{this.props.auth0contactError ? this.props.auth0contactError.error : ''}</b></p>
                                                <p>id: <b>{this.props.auth0contactError ? this.props.auth0contactError.id : ''}</b></p>
                                                <p>mail: <b>{this.props.auth0contactError ? this.props.auth0contactError.mail : ''}</b></p>
                                                <p>verificata: <b>{this.props.auth0contactError && this.props.auth0contactError.verifiedMail ? "SI" : 'NO'}</b></p>
                                                <p>
                                                    elimina:
                                                    <DeleteX action={() => this.goToOblivion(this.props.auth0contactError.id, true)}
                                                        text={'Eliminazione definitiva utente. Verranno cancellate tutte le informazioni collegate e non saranno più recuperabili. Sei sicuro di voler proseguire?'} />
                                                    <br />
                                                    <b>Attenzione!</b> L'utente verrà eliminato definitivamente e non sarà più recuperabile.</p>
                                            </>
                                        </Alert>
                                    </Grid>
                                    :
                                    <Grid item xs={12}>
                                        {!this.props.contact ?
                                            <>
                                                <NewContact addNewUser={this.addNewUser} />
                                            </> :
                                            <>
                                                <Contact
                                                    contact={this.props.contact}
                                                    blockAccessOn={this.props.setBlockDate}
                                                    openContactReservationDialog={() => { this.setOpenContactReservationDialog(true) }}
                                                    openInformationDialog={() => { this.setOpenInformationDialogList(true) }}
                                                    openReminderDialog={() => { this.setOpenReminderDialogList(true) }}
                                                    openContactAccessDialog={() => { this.setOpenAccessDialog(true) }}
                                                    addSubscriptionType={this.getSubscriptionType}
                                                />
                                                <ContactReservationDialog
                                                    contact={this.props.contact ? this.props.contact : emptyContact()}
                                                    isContactReservationFetchInError={this.props.isContactReservationFetchInError}
                                                    loadingReservations={this.props.isLoadingContactReservations}
                                                    onCancel={() => {
                                                        if (!this.props.isLoadingContactReservations) {
                                                            this.setOpenContactReservationDialog(false)
                                                        }
                                                    }}
                                                    open={this.state.openContactReservationDialog}
                                                    reservations={this.props.contactReservations}
                                                />
                                                <AccessDialog
                                                    open={this.state.openContactAccessDialog}
                                                    sub={this.state.selectedSub}
                                                    passage={this.state.passage}
                                                    roomList={this.props.rooms}
                                                    onCancel={() => { this.setOpenAccessDialog(false) }}
                                                    onSave={this.saveAccess}
                                                />
                                                <ReminderDialogList
                                                    open={this.state.openReminderDialogList}
                                                    onCancel={() => { this.setOpenReminderDialogList(false) }}
                                                    doneReminder={this.doneReminder}
                                                    newReminder={this.newReminder}
                                                    openReminder={this.openReminder}
                                                    reminderList={this.props.selectedContactReminders}
                                                    isLoadingReminders={this.props.isLoadingReminders}
                                                    classes={this.props.classes}
                                                />
                                                <ReminderDialog
                                                    open={this.state.openReminderDialog}
                                                    reminder={this.state.reminder === undefined ? emptyReminder(this.props.contact.email, this.props.contact.sub) : this.state.reminder}
                                                    onCancel={() => { this.setOpenReminderDialog(false) }}
                                                    onSave={this.saveReminder}
                                                    classes={this.props.classes}
                                                />
                                                <InformationDialog
                                                    open={this.state.openInfosDialog}
                                                    isLoadingInfos={this.props.isLoadingInfos}
                                                    informations={this.props.informations === undefined ? [] : this.props.informations}
                                                    onCancel={() => { this.setOpenInformationDialogList(false) }}
                                                    onSave={this.saveInfos}
                                                    onDelete={this.deleteInfos}
                                                    classes={this.props.classes}
                                                    contact={this.props.contact}
                                                />
                                                <AddContactSubscriptionDialog
                                                    open={this.state.openSubscriptionDialog}
                                                    dialogType={this.state.subscriptionType}
                                                    onCancel={() => this.setOpenSubscriptionDialog(false, '')}
                                                    onSaveSubscription={this.saveSubscription}
                                                    onSaveInsurance={this.saveInsurance}
                                                    onSaveMedicalExamination={this.saveMedicalExamination}
                                                    classes={this.props.classes}
                                                    userId={this.props.contact.sub}
                                                />

                                                <Buttons print={() => { this.printElem("ContactData") }}
                                                    save={null}
                                                    undo={null}
                                                    oblivion={() => this.goToOblivion(this.props.contact.sub, false)}
                                                    download={null} />
                                            </>}
                                    </Grid>
                                )}
                        </Grid>
                    </Paper>
                    {/* } */}
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => {
    const selectedContactReminders = state.reminders.selectedContactReminders;
    const informations = state.infos.informations;
    const isLoadingReminders = state.reminders.isLoadingReminders;
    // const contactSubscriptions = state.subscriptions.contactSubscriptions;
    // const isLoadingSubscriptions = state.subscriptions.isLoadingSubscriptions;
    // contactSubscriptions, isLoadingSubscriptions,
    return { ...state.contacts, ...state.tags, ...state.rooms, selectedContactReminders, informations, isLoadingReminders, ...ownP, }
}

// const mapStateToProps = (state: IApplicationState, ownP) => ({
//     ...state.contacts,
//     ...state.reminders.selectedContactReminders,
//     ...state.tags,
//     ...ownP
// })

const mapDispatchToProps = (dispatch: any) => ({
    ...contactActions(dispatch),
    ...subscriptionsActions(dispatch),
    ...remindersActions(dispatch),
    ...infosActions(dispatch),
    ...tagsActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const Contacts = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles as any)(WithMediaQuery(CompContainer)));